import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64dc46c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "acordeon-sticky right-side-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title-block" }, "My Campaign", -1))
const _hoisted_3 = { class: "p-d-flex p-justify-center p-mt-4" }
const _hoisted_4 = { class: "p-pl-6 p-pr-6 p-mb-6 p-mt-4 campaign-name" }
const _hoisted_5 = { class: "completed" }
const _hoisted_6 = { class: "acordeon-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-main-acordeon" }, "Campaign details", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-main-acordeon" }, "Influencer Instructions", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-main-acordeon" }, "Budget", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_campaign_photo = _resolveComponent("campaign-photo")!
  const _component_change_campaign_logo = _resolveComponent("change-campaign-logo")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    ($props.isProductSteep)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          label: "edit cover image",
          class: "continue-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showModalChangeLogo = true))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_campaign_photo, {
        "campaign-photo": $setup.mainPhoto,
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.isProductSteep ? $setup.showModalChangeLogo = true : null)),
        class: "photo-campaign"
      }, null, 8, ["campaign-photo"]),
      _createVNode(_component_change_campaign_logo, {
        "previous-photo": $setup.previousPhotos,
        "main-image": $setup.mainPhoto,
        onClose: $setup.closeModalLogo,
        "show-change-logo-modal": $setup.showModalChangeLogo,
        onChangePhoto: $setup.changePhoto
      }, null, 8, ["previous-photo", "main-image", "onClose", "show-change-logo-modal", "onChangePhoto"])
    ]),
    _createElementVNode("h3", _hoisted_4, _toDisplayString($props.name), 1),
    _createElementVNode("span", _hoisted_5, _toDisplayString($setup.totalProgressCount) + "% completed", 1),
    _createVNode(_component_ProgressBar, {
      value: $setup.totalProgressCount,
      showValue: false,
      class: "progressCompleted"
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["acordeon-item", [$props.details ? 'done-icon' : '']])
      }, _hoisted_8, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["acordeon-item", [$props.instructions ? 'done-icon' : '']])
      }, _hoisted_10, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["acordeon-item", [$props.budget ? 'done-icon' : '']])
      }, _hoisted_12, 2)
    ])
  ]))
}